import { gql } from '__generated__';

export default gql(`
  query GetEventsForMailPermissions($id: ID!) {
    project(id: $id) {
      id
      events {
        data {
          id
          title
        }
      }
    }
  }
`);
